import { ActionListItem } from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";

export const AtsIntegrationRowSkeleton = () => {
  return (
    <ActionListItem
      alignItems="center"
      leading={<Skeleton width="20px" height="20px" />}
      leadingSize="space-10"
      trailing={<Skeleton width="60px" height="20px" />}
      centerAlignTrailing
    >
      <Skeleton width="80%" height="20px" />
    </ActionListItem>
  );
};
